import { useEffect } from 'react';
import { LogLevel, setLogLevel } from 'livekit-client';
import { useRoomContext } from '@livekit/components-react';

/**
 * Enables debug mode for LiveKit room.
 * Sets log level and exposes room instance to window for debugging.
 * 
 * @param options - Debug mode configuration
 * @param options.logLevel - LiveKit log level (default: 'debug')
 * @param options.enabled - Whether debug mode is enabled (default: true)
 */
export function useDebugMode(options: { logLevel?: LogLevel; enabled?: boolean } = {}) {
    const room = useRoomContext();
    const logLevel = options.logLevel ?? 'debug';
    const enabled = options.enabled ?? true;

    useEffect(() => {
        if (!enabled) {
            setLogLevel('silent');
            return;
        }

        setLogLevel(logLevel ?? 'debug');
        (window as any).__lk_room = room;

        return () => {
            (window as any).__lk_room = undefined;
            setLogLevel('silent');
        };
    }, [room, enabled, logLevel]);
}
